var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"predefined transmit-document"},[_vm._v("TRANSMIT_DOCUMENT")])
}
var staticRenderFns = []

export { render, staticRenderFns }